import { useEffect, useState } from 'react'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

export default function useNetwork() {
  const { showNetworkMessage } = getInstoreConfig()
  const [isOnline, setNetwork] = useState(
    window.navigator.onLine || !showNetworkMessage
  )

  useEffect(() => {
    const updateNetwork = () => {
      setNetwork(window.navigator.onLine || !showNetworkMessage)
    }

    window.addEventListener('offline', updateNetwork)
    window.addEventListener('online', updateNetwork)

    return () => {
      window.removeEventListener('offline', updateNetwork)
      window.removeEventListener('online', updateNetwork)
    }
  }, [showNetworkMessage])

  return isOnline
}
